import { Td, Tr } from '@chakra-ui/table';
import useCurrencyText from 'hooks/shared/useCurrencyText';
import moment from 'moment';
import { FC } from 'react';

const OperationTableRow: FC<OperationListItem> = ({
  name,
  amount,
  currency,
  date,
  info,
  assetType,
  quantity,
  direction,
}) => {
  const currencyText = useCurrencyText();

  const getSignPrefix = (): string => {
    if (direction === 'INCOME') return '+';
    if (direction === 'OUTCOME') return '—';

    return '';
  };

  return (
    <Tr>
      <Td>{name}</Td>
      <Td>{moment(date).format('lll')}</Td>
      <Td>{getSignPrefix()}{assetType === 'INFO' ? currencyText(quantity ?? 0, { symbol: info ?? '' }) : currencyText(amount, { symbol: currency.symbol })}</Td>
    </Tr>
  );
};

export default OperationTableRow;
